import { useEffect, useState } from 'react';
import { publicApi } from '@/lib/api';

/* Lightweight shared content/settings cache + hook. */
let contentCache = null;
let settingsCache = null;
let contentPromise = null;
let settingsPromise = null;

export const usePublicContent = () => {
    const [content, setContent] = useState(contentCache);
    const [settings, setSettings] = useState(settingsCache);
    const [loading, setLoading] = useState(!contentCache || !settingsCache);

    useEffect(() => {
        let cancel = false;
        const load = async () => {
            try {
                if (!contentCache) {
                    contentPromise = contentPromise || publicApi.getContent();
                    contentCache = await contentPromise;
                }
                if (!settingsCache) {
                    settingsPromise = settingsPromise || publicApi.getSettings();
                    settingsCache = await settingsPromise;
                }
                if (!cancel) {
                    setContent(contentCache);
                    setSettings(settingsCache);
                    setLoading(false);
                }
            } catch {
                if (!cancel) setLoading(false);
            }
        };
        load();
        return () => {
            cancel = true;
        };
    }, []);

    return { content: content || {}, settings: settings || {}, loading };
};
